import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { PlusCircle, Trash2 } from 'lucide-react';

const ApplianceOptionsDialog = ({ isOpen, onClose, onDelete, onAddAnother, applianceName }) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-center">{applianceName} Options</DialogTitle>
                </DialogHeader>

                <div className="grid grid-cols-1 gap-4 py-4">
                    <Button variant="destructive" onClick={onDelete} className="flex items-center justify-center gap-2">
                        <Trash2 className="w-4 h-4" />
                        Remove Appliance
                    </Button>

                    <Button variant="outline" onClick={onAddAnother} className="flex items-center justify-center gap-2">
                        <PlusCircle className="w-4 h-4" />
                        Add Another {applianceName}
                    </Button>
                </div>

                <DialogFooter>
                    <Button variant="secondary" onClick={onClose} className="w-full">
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ApplianceOptionsDialog;
